import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Tag, Typography } from '@navi/web-ui/lib/primitives';
import { IAllBankAccountDetails } from './interface';
import EllipsisText from '@cp/src/components/EllipsisText';
import BankDetailsComponent from './BankDetailsComponent';
import { Tooltip, TooltipContent, TooltipTrigger } from '@cp/src/components/TooltipV2/TooltipV2';
import { getAllBankAccountDetails } from './action';
import { isAccountTypeMandate, isBankNameLong } from './utils';
import { PAYMENT_MODE } from '../../interfaces/RepaymentHistory.type';
import { PLACEHOLDER_DASH } from './const';

const AllBankDetailsDrawer = () => {
  const { customerId = '' } = useParams();
  const [bankDetails, setBankDetails] = useState<IAllBankAccountDetails[]>([]);

  const fetchBankAccountDetails = async () => {
    const bankAccountDetails = await getAllBankAccountDetails(customerId);
    setBankDetails(bankAccountDetails);
  };

  useEffect(() => {
    if (customerId) {
      fetchBankAccountDetails();
    }
  }, [customerId]);

  return (
    <div className="w-full max-w-xl mx-auto">
      {bankDetails?.map((account, index) => (
        <div key={index} className="flex justify-between items-center mb-4">
          <div className="flex-grow ">
            <div className="flex flex-row justify-between">
              <div
                className={
                  isAccountTypeMandate(account?.instrumentType) ? 'w-[228px]' : 'w-[328px]'
                }
              >
                <Tooltip placement="top">
                  <TooltipTrigger tooltipTriggerClassName="tooltipTriggerWrapper">
                    <Typography variant="h4" color="var(--navi-color-gray-c1)">
                      <EllipsisText text={account?.bankName} ellipsisWrapperClass={''} />
                    </Typography>
                  </TooltipTrigger>
                  {isBankNameLong(account?.bankName) ? (
                    <TooltipContent className={'tooltipWrapper'}>
                      {account?.bankName}
                    </TooltipContent>
                  ) : null}
                </Tooltip>
              </div>

              {isAccountTypeMandate(account?.instrumentType) ? (
                <Tag color="blue" label={PAYMENT_MODE.E_NACH} variant="transparent" size="sm" />
              ) : null}
            </div>

            <div className="flex flex-row items-center pl-4 justify-between mt-3 p-3 bg-[var(--navi-color-gray-bg-secondary)]">
              <BankDetailsComponent
                label="IFSC code"
                value={account?.bankIfsc || PLACEHOLDER_DASH}
              />
              <BankDetailsComponent
                label="Account number"
                value={account?.bankAccountNumber || PLACEHOLDER_DASH}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AllBankDetailsDrawer;
